import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";

import ShopManagement from "./shop-management/index.vue";
import AreaManagement from "./area-management/index.vue";
const __default__ = {
  name: "ShopConfigManagement",
  components: {
    ShopManagement,
    AreaManagement,
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  terminal: String,
  curUser: Object,
  areaManageShowPerm: {
    type: String || null,
    default: null,
  },
  areaManageCreatePerm: {
    type: String || null,
    default: null,
  },
  areaManageEditPerm: {
    type: String || null,
    default: null,
  },
  shopManageCreateBtnPerm: {
    type: String || null,
    default: null,
  },
  shopManageEditBtnPerm: {
    type: String || null,
    default: null,
  },
  shopManageImportBtnPerm: {
    type: String || null,
    default: null,
  },
},
  setup(__props) {

const props = __props


const current = ref<"shop-management" | "area-management">("shop-management");

const handleEvent = (event: { type: string }) => {
  if (event.type === "toShopManagement") {
    current.value = "shop-management";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (current.value === 'shop-management')
      ? (_openBlock(), _createBlock(ShopManagement, {
          key: 0,
          curUser: __props.curUser,
          terminal: __props.terminal,
          shopManageCreateBtnPerm: __props.shopManageCreateBtnPerm,
          shopManageEditBtnPerm: __props.shopManageEditBtnPerm,
          shopManageImportBtnPerm: __props.shopManageImportBtnPerm,
          onEvent: handleEvent
        }, null, 8, ["curUser", "terminal", "shopManageCreateBtnPerm", "shopManageEditBtnPerm", "shopManageImportBtnPerm"]))
      : _createCommentVNode("", true),
    (current.value === 'area-management')
      ? (_openBlock(), _createBlock(AreaManagement, {
          key: 1,
          curUser: __props.curUser,
          terminal: __props.terminal,
          areaManageCreatePerm: __props.areaManageCreatePerm,
          areaManageEditPerm: __props.areaManageEditPerm,
          onEvent: handleEvent
        }, null, 8, ["curUser", "terminal", "areaManageCreatePerm", "areaManageEditPerm"]))
      : _createCommentVNode("", true)
  ]))
}
}

})